import ape from '../assets/category-ape.png'
import droid from '../assets/category-droid.png'
import weapon from '../assets/category-weapon.png'
import lootbox from '../assets/category-lootbox.png'
import { useMarketplace } from '../context'
import { twMerge } from 'tailwind-merge'

interface CategoryProps {
    slug: string
    name: string
    type: string
    image: string
}

function Category({ slug, name, type, image }: CategoryProps) {
    const { state, setCollection } = useMarketplace()
    const isActive = state.collection.toLowerCase() === slug.toLowerCase()
    return (
        <div
            className={twMerge(
                isActive
                    ? 'bg-[linear-gradient(90deg,rgba(201,31,255,0.25)_3.2%,rgba(3,206,255,0.25)_97.74%)] cursor-default'
                    : 'bg-[#282828] cursor-pointer',
                'hover:bg-[linear-gradient(90deg,rgba(201,31,255,0.25)_3.2%,rgba(3,206,255,0.25)_97.74%)] font-bold text-center flex flex-col text-[max(8px,0.5cqi)] p-[1em] gap-[1em] min-w-56 flex-1 basis-0 snap-center select-none'
            )}
            onClick={() => setCollection(slug)}
        >
            <div
                className='bg-center bg-no-repeat bg-cover flex flex-col justify-end  uppercase pb-[1em]'
                style={{
                    backgroundImage: `linear-gradient(0deg,#000 5%,rgba(0,0,0,0) 55%),url(${image})`,
                    aspectRatio: '360/215',
                }}
            >
                <div className='text-[2em]'>{name}</div>
                <div className='text-[1.5em] text-white/65'>{type}</div>
            </div>
            <div className='text-[1.5em] whitespace-nowrap'>
                {isActive ? 'EXPLORING COLLECTION' : 'VIEW COLLECTION'}
            </div>
        </div>
    )
}

function CategoryApe() {
    return <Category slug='ape' name='Ape' type='Operatives' image={ape} />
}

function CategoryDroid() {
    return <Category slug='droid' name='Droid' type='Operatives' image={droid} />
}

function CategoryWeapon() {
    return <Category slug='weapon' name='Weapon' type='Skins' image={weapon} />
}

function CategoryLootbox() {
    return <Category slug='lootbox' name='Loot' type='Boxes' image={lootbox} />
}

Category.Ape = CategoryApe
Category.Droid = CategoryDroid
Category.Weapon = CategoryWeapon
Category.Lootbox = CategoryLootbox

function CategoryList() {
    return (
        <div className='container-inline flex flex-row gap-x-4 px-4 overflow-x-auto snap-x snap-mandatory'>
            <Category.Ape />
            <Category.Droid />
            <Category.Weapon />
            <Category.Lootbox />
        </div>
    )
}

export { Category, CategoryList }
